<div style="flex-grow: 1;display: flex;flex-direction: column;overflow: hidden;">
  <!-- Header -->
  <div class='flex-header'></div>
  <!-- Body -->
  <div class='flex-content'>
    <div style="height:100%; display: flex;flex-direction: column;overflow: auto;">
      <mat-table #table [dataSource]="dataSource" matSortDisableClear matSort id="tblDataDefDynamicGrid" cdkDropList
        (cdkDropListDropped)="rowDrop($event)" [cdkDropListDisabled]="!dataDefList.IsSortable"
        [matSortDisabled]="dataDefList.IsSortable">

        <!-- Drag Handle Column -->
        <ng-container matColumnDef='drag-handle'>
          <mat-header-cell *matHeaderCellDef translate>
            <!-- DELIBERATELY LEFT BLANK -->
          </mat-header-cell>
          <mat-cell *matCellDef="let field" cdkDragHandle>
            <img alt="Re-Order" title="Re-Order" src="./assets/images/grip.png" style="width: 10px">
          </mat-cell>
        </ng-container>

        <!-- Dynamic Columns -->
        <ng-container *ngFor="let column of columns">

          <!-- string or int or float -->
          <ng-container matColumnDef="{{column.ColumnName}}" *ngIf="column.DataType != 'boolean'">

            <mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="{'justify-content': (column.DataType == 'number' || column.DataType == 'float') ? 'right' : 'left'}">
              <div
                [ngStyle]="{'text-align': (column.DataType == 'number' || column.DataType == 'float') ? 'right' : 'left', 'width': '100%'}">
                {{ column.DisplayName }}
              </div>
              <filter class="mat-filter" [data]="dataSource" columnName="{{column.ColumnName}}"
                [dataType]='getFilterType(column.DataType)'></filter>
            </mat-header-cell>

            <mat-cell *matCellDef="let row">
              <div
                [ngStyle]="{'text-align': (column.DataType == 'number' || column.DataType == 'float') ? 'right' : 'left', 'width': '100%', 'padding-right': (column.DataType == 'number' || column.DataType == 'float') ? '24px' : '0px'}">
                {{column.Cell(row)}}
              </div>
            </mat-cell>

          </ng-container>

          <!-- boolean -->
          <ng-container matColumnDef="{{column.ColumnName}}" *ngIf="column.DataType == 'boolean'">
            <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'cellAlign': true}">
              {{ column.DisplayName }}
              <filter [data]="dataSource" columnName="{{column.ColumnName}}" [dataType]="getFilterType(column.DataType)"
                trueValue="true" falseValue="false" showTrueLabel="Y" showFalseLabel="" class="mat-filter"></filter>
            </mat-header-cell>
            <mat-cell [ngClass]="{'cellAlign': true}" *matCellDef="let row">
              <div class="contentDiv">{{column.Cell(row) === 'true' ? 'Y' : ''}}</div>
            </mat-cell>
          </ng-container>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="Actions">
          <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
          <mat-cell *matCellDef="let row; let i = dataIndex;">
            <tyl-mat-menu id="tblLookupActionMenu{{i}}" image="actions.png" [iconWidth]="30">
              <button *ngIf="dataDefList.LockSystemCodes" id="edit{{i}}" aria-label="edit" mat-menu-item
                class="menuItem" (click)="editClick(row)">{{(row.IsSysGen == true)? 'View' :
                'Edit'}}</button>
              <button *ngIf="!dataDefList.LockSystemCodes" id="edit{{i}}" aria-label="edit" mat-menu-item
                class="menuItem" (click)="editClick(row)">Edit</button>
              <button id="delete{{i}}" aria-label="delete" mat-menu-item class="menuItem"
                (click)="deleteClick(row)">Delete</button>
            </tyl-mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple cdkDrag [cdkDragData]="row">
        </mat-row>
      </mat-table>
    </div>
  </div>